import React, { useCallback, useContext, useState } from 'react';
import useOutsideClick from '../welcome/useOutsideClick';
import { TodoContext } from './Project';
import TaskActionPopeye from './TaskActionPopeye';
import './TodoLine.css';

export default function TodoLine({taskLine}) {
  
  const {tasks, updateTask, isPopeyeOn, setPopeyeOn} = useContext(TodoContext);
  const task = tasks.filter(task => task.id === taskLine.id)[0];

  const [showMenu, setShowMenu] = useState(false);
  const [lastPos, setLastPos] = useState({x:0, y:0});

  const [inputText, setInputText] = useState(task.text);

  const closePopeye = useCallback(() => {
    setShowMenu(false);
    setPopeyeOn(false);
  }, [setPopeyeOn, setShowMenu]);

  const openPopeye = () => {
    setShowMenu(true);
    setPopeyeOn(true);
  }

  const setPopeye = (b) => {
    return b ? openPopeye() : closePopeye();
  }

  const handleClickOutsidePopup = useCallback(() => {
    closePopeye();
  },[closePopeye]);

  const ref = useOutsideClick(handleClickOutsidePopup);

  const handleRightClick = (e) => {
    e.preventDefault();
    
    if (isPopeyeOn) {
      return;
    }

    
    setLastPos({x: e.screenX, y:e.screenY});    
    openPopeye();
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      console.log('---[Enter]')
      e.target.blur();
    }
  }

  const handleChange = (e) => {
    task.text = e.target.value;
    setInputText(e.target.value);    
    updateTask(task);
  }

  const statusStyle = `todoLine ${task.progress}`;

  return (
    <div className='todoLine' onContextMenu={handleRightClick}>
      <input className={statusStyle} type='text' onKeyDown={handleKeyDown} onChange={handleChange} value={inputText} placeholder={taskLine.kiponosInfo?.isNew ? 'New Task': ''}/>
      <TaskActionPopeye id={taskLine.id} pos={lastPos} visible={showMenu} setVisible={setPopeye} aRef={ref}/>
    </div>
  )
}
